import { useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import useStoreAuth from 'src/hooks/useStoreAuth';
import { authInitialState } from 'src/store/features/authSlice';

import useAuth from '@hooks/useAuth';
import { useLogout } from '@hooks/users';
import useStoreAppConfig from '@hooks/useStoreAppConfig';

import { LayoutSplashScreen } from '_metronic/layout';

export default function Logout(): JSX.Element {
  const auth = useAuth();
  const [, { resetSelectedHotels }] = useStoreAppConfig();
  const [, { setAuth }] = useStoreAuth();
  const { logout } = useLogout({ onError: (error: unknown) => console.error(error) });
  const hasLoggedOutRef = useRef(false);

  useEffect(() => {
    if (hasLoggedOutRef.current) {
      return;
    }
    hasLoggedOutRef.current = true;

    // Settle the logout request BEFORE clearing local state. The 401 interceptor may
    // transparently refresh-and-retry it (the access token is often expired at
    // sign-out time), and that flow must run while the auth pair is still in the
    // store: resetting first would strand the retry without credentials and open a
    // window for the refresh helper to re-adopt the persisted pair into an already
    // signed-out session. The splash screen keeps rendering until the reset flips
    // `auth`, so the ordering is invisible to the user.
    void logout({ refresh: auth?.refresh ?? undefined })
      .catch(() => {})
      .finally(() => {
        setAuth(authInitialState);
        resetSelectedHotels();
      });
  }, [auth, logout, resetSelectedHotels, setAuth]);

  return auth ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
}
